import { MultiSelect } from '@mantine/core';
import { useList } from '../api/hooks/useCrud.ts';
import type { Language } from '../api/schemas/entities.ts';

/**
 * The legacy schema stores `languages` as a comma-separated string of language
 * ids on the Visitor table. This component reads/writes that string while
 * presenting a multi-select to the user.
 */
export function LanguageMultiselect({
  value,
  onChange,
  label,
}: {
  value: string | null | undefined; // comma-separated ids
  onChange: (csv: string) => void;
  label?: string;
}) {
  const { data } = useList<Language>('languages');
  const options = (data ?? [])
    .filter(l => l.id != null)
    .map(l => ({ value: String(l.id), label: l.name ?? `#${l.id}` }));
  const selected = (value ?? '').split(',').map(s => s.trim()).filter(Boolean);
  return (
    <MultiSelect
      label={label ?? 'Languages'}
      data={options}
      value={selected}
      onChange={vs => onChange(vs.join(','))}
      searchable
      clearable
    />
  );
}
